const ModalEvent = {
  SAVE_CUSTOM_DIAGRAM: 'saveCustomDiagram',
  OPEN_DIAGRAM_MODAL: 'openDiagramModal',
  EDIT_DIAGRAM_MODAL: 'editDiagramModal',
  DELETE_DIAGRAM_MODAL: 'deleteDiagramModal',
  MISSING_MINUTE_VALUES_MODAL: 'missingMinuteValues',
};

export default ModalEvent;
